import moment from 'moment'
export const filter = {
    day: new Date().getDay(),
    specialties: [],
    date: moment(new Date()).format('YYYY-MM-DD')
};
